import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/routeHead";
import RVManuals from "@/pages/RVManuals";

export const Route = createFileRoute("/rv-manuals")({
  head: () => pageHead({
    title: 'RV Owner Manuals',
    description: 'Download owner manuals and component guides for your RV — Rex & Sons RVs helps you find documentation for appliances, awnings and more.',
    path: '/rv-manuals',
  }),
  component: RVManuals,
});
